// Расшифровка → markdown для выгрузки в DOCX/PDF.
//
// bit-export печатает markdown, а расшифровка — плоский текст, где реплики
// разделены одиночным переводом строки. В markdown такой перевод — пробел, и
// pandoc склеивал весь разговор в один абзац (обращение владельца 16.09.2026:
// «сплошным текстом без абзацев, читать невозможно»). Собираем документ из тех
// же реплик, что рисует интерфейс (parseTranscriptText → groupTurns): имя
// участника, под ним фразы со временем — не хуже, чем на экране.
import { parseTranscriptText, groupTurns } from './transcriptParse';
import { cleanSpeakerName } from '../components/protocol/speakerLabels';

// Речь человека — не разметка: звёздочка, решётка, скобки печатаются как есть.
export function escapeMarkdown(text) {
  return String(text || '').replace(/[\\`*_{}[\]()#+\-!<>|~]/g, '\\$&');
}

const timecodeOf = (value) => (value ? String(value).replace(/[[\]]/g, '').trim() : '');

export function transcriptToMarkdown(text, { showTimecodes = true } = {}) {
  if (!text || !String(text).trim()) return '';
  const fragments = parseTranscriptText(text);

  if (!fragments) {
    // Меток нет — просто абзацы по строкам.
    return String(text).split('\n').map((l) => l.trim()).filter(Boolean)
      .map(escapeMarkdown).join('\n\n');
  }

  const turns = groupTurns(fragments);
  const blocks = [];
  turns.forEach((turn) => {
    if (turn.speaker) blocks.push(`**${escapeMarkdown(cleanSpeakerName(turn.speaker) || 'Без имени')}**`);
    // Как в TranscriptView: с временем — каждая фраза своей строкой, без — блок целиком.
    const parts = showTimecodes && (turn.parts || []).length > 1
      ? turn.parts
      : [{ timecode: turn.timecode, text: turn.text }];
    parts.forEach((part) => {
      const body = escapeMarkdown(part.text);
      const tc = showTimecodes ? timecodeOf(part.timecode) : '';
      if (body || tc) blocks.push(tc ? `*${tc}* ${body}`.trim() : body);
    });
  });
  return blocks.join('\n\n');
}
